import axios from 'axios';
import { getRequest, getUserToken, postRequest } from 'src/shared/AppUtils';

export function getBooksApi({
  pageSize,
  page,
  params,
  selectedGroup,
  selectedInventory,
  ebookSearch,
}) {
  return postRequest(
    `Book/SearchOpac?recordGroupId=${selectedGroup}&inventoryId=${selectedInventory}&ebookSearch=${ebookSearch}&startIndex=${
      (page - 1) * pageSize
    }&count=${pageSize}`,
    params
  );
}

export function getBookRecordGroupsApi() {
  return getRequest('Dics/RecordGroups?type=0');
}

export function getInventoriesApi() {
  return getRequest('Dics/Inventories?campusId=');
}

export function getRecordContentApi(params) {
  return getRequest('Book/GetRecordContent', { params });
}

export function checkPermit(fileId) {
  const token = getUserToken();
  return postRequest(
    'ebook/CheckPermit',
    {
      type: 'book',
      id: fileId,
    },
    {
      headers: {
        Token: token,
      },
    }
  );
}

export function clickCount(bookid) {
  return axios.get(`${window.getLinkHomepage()}api/Book/ClickCount`, {
    params: { bookid },
  });
}

export function reserveBookApi(bookid, inventoryId) {
  const Token = getUserToken();
  return axios.get(`${window.getLinkHomepage()}api/Reader/ReserveBook`, {
    params: { id: bookid, inventory: inventoryId, receive: inventoryId },
    headers: {
      Token,
    },
  });
}
